import { createSelector } from 'reselect'
import { createSelector as ormCreateSelector } from 'redux-orm'
import orm from '../../models/models'

export const getCategoryRelationships = createSelector(
  state => state.orm,
  state => state.orm.PlanCategoryPlanSubcategories.items,
  ormCreateSelector(orm, session => {
    return session.PlanCategoryPlanSubcategories.all()
  })
)

export const subcategoriesExist = createSelector(
  state => state.orm,
  ormCreateSelector(
    orm,
    session => session.PlanCategoryPlanSubcategories.count() > 0
  )
)
